$("body").on("click", ".editImage", function () {
  // Get the modal and modal content elements
  var modal = new bootstrap.Modal(document.getElementById("modalChangeImage"));
  var modalContent = $("#modalContentImage");

  let changesId = $(this).data("id");
  // Perform AJAX request to fetch content
  $.ajax({
    url: "api__loadModalChangeImage?changesId=" + changesId, // Replace 'your_content_url' with the URL that returns the content you want to load.
    type: "GET",

    success: function (response) {
      // Update modal content with the fetched data
      modalContent.html(response);
      // Show the modal

      modal.show();

      $("body")
        .off("change", "#fileInput")
        .on("change", "#fileInput", function () {
          const fileInput = document.getElementById("fileInput");
          const preview = document.getElementById("preview");

          const file = fileInput.files[0];
          const reader = new FileReader();

          reader.onload = function (e) {
            preview.innerHTML = `<img src="${e.target.result}"  class="img-fluid" alt="Preview"   />`;
          };

          reader.readAsDataURL(file);
        });
    },
    error: function () {
      modalContent.html("Error loading content.");
    },
  });
});

jQuery("body").on("custom__modalChangeImageFinish", function (e, a, b) {
    console.log("custom__modalChangeFinish....");
    console.log(a);
    console.log(b);
    changeTable.ajax.reload();
    $("#modalChangeImage").modal("hide");
  });